function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      position: absolute;\n      top: ",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  align-items: center;\n  background-color: ",
        ";\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  height: 61px;\n  left: 0;\n  justify-content: flex-start;\n  opacity: ",
        ";\n  padding: 15px;\n  position: fixed;\n  right: 0;\n  top: -61px;\n  transform: ",
        ";\n  transition: 0.2s transform, 0.2s opacity;\n  z-index: 9999;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  margin-right: 15px;\n  width: 32px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #fff;\n  font-size: 14px;\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import _ from 'lodash';
import styled, { css } from 'styled-components';
var backgroundColorMapping = {
    danger: '#da5347',
    error: '#da5347',
    info: '#1b9edb',
    success: '#75ba50'
};
export var Container = styled.div(_templateObject1(), function(props) {
    return _.get(backgroundColorMapping, props.type, backgroundColorMapping.danger);
}, function(props) {
    return props.visible ? 1 : 0;
}, function(props) {
    return props.visible ? 'translate3d(0, 61px, 0)' : 'translate3d(0, 0, 0)';
}, function(param) {
    var isIframe = param.isIframe, iframeOffset = param.iframeOffset, parentOffset = param.parentOffset;
    return isIframe && css(_templateObject(), parentOffset + iframeOffset - 61);
});
export var IconContainer = styled.div(_templateObject2());
export var Message = styled.span(_templateObject3());
export default {
    Container: Container,
    IconContainer: IconContainer,
    Message: Message
};
